import { AnalyticsBrowser } from '@segment/analytics-next'
import type { Analytics, User } from '@segment/analytics-next'
import type { AnalyticsEvents } from 'types/events/events'

const analytics = new AnalyticsBrowser()

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSegment = () => {
  const user = (): Promise<User> => {
    return analytics.user()
  }

  const track = async <K extends keyof AnalyticsEvents>(event: K, properties: AnalyticsEvents[K]): Promise<void> => {
    await analytics.track(event, properties)
  }

  const trackLink = async <E extends HTMLElement, K extends keyof AnalyticsEvents>(
    element: E,
    event: K,
    properties: AnalyticsEvents[K]
  ): Promise<void> => {
    await analytics.trackLink(element, event, properties)
  }

  const identify = async (traits: Record<string, unknown>): Promise<void> => {
    await analytics.identify(traits)
  }

  const page = async (): Promise<void> => {
    await analytics.page()
  }

  const load = (): Promise<Analytics> => {
    const promise = new Promise<Analytics>((resolve, reject) => {
      analytics
        .load({ writeKey: import.meta.env.PUBLIC_SEGMENT_WRITE_KEY })
        .then(([instance]) => {
          // Make analytics instance globally available
          ;(window as any).analytics = instance

          resolve(instance)
        })
        .catch((error) => reject(error))

      // Automatically track the initial page load
      page()
    })

    return promise
  }

  return {
    user,
    load,
    track,
    trackLink,
    identify,
  }
}
